export const UPDATE_AWARDING_RULE = 'UPDATE_AWARDING_RULE';
export const RESET_AWARDING_RULE = 'RESET_AWARDING_RULE';
